
import CurrencyFormatter from '../../utils/currency-formatter-lib';
import Tooltip from '../../utils/tooltip';
import AnalyticsHelper from '../../utils/analytics-helper';
import { escapeHTML } from '../../utils/promotions-helper';
export default class SummaryView {
    constructor(parent) {
        this.parent = parent;
        this.navigation = parent.navigation;
        this.el = parent.el.querySelector('.configurator--summary');
        this.data = parent.data;
        this.car = parent.car;
        this.pricing = parent.pricing;
        this.finance = parent.finance;
        this.partEx = parent.partEx;
        this.promotionsHelper = parent.promotionsHelper;
        this.checkoutSession = parent.checkoutSession;
        this.linkParams = parent.linkParams;
        this.stockChecker = parent.stockChecker;
        this.pricingSource = parent.pricingSource;
        this.waitForFirstLoad = new Promise((resolve) => {
            this.loaded = resolve;
        });

        (this.template = _.template(
            this.el
                .querySelector('#configurator--summary-template')
                .innerHTML.replaceAll('\\', '')
        )),
            (this.priceFormatter = new CurrencyFormatter({
                decimals: HONDA.currency.roundToDecimalPlaceFinance ?? 0,
            }));
        this.aprFormatter = (val) =>
            `${val.toFixed(
                +HONDA.currency.roundToDecimalPlaceFinanceAPR || 1
            )}%`;
        this.percentFormatter = (val) =>
            `${val.toFixed(
                +HONDA.currency.roundToDecimalPlaceFinancePercent || 1
            )}%`;

        this.content = this.el.querySelector('.summary-content');
        this.orderButton = this.el.querySelector('.order-button');
        this.loader = this.el.querySelector('.summary-loader');
        this.termsLink = this.el.querySelector('.terms-link');

        this.orderButtons = this.el.querySelector('.summary-begin-order');
        this.saveConfigButton = this.el.querySelector('.save-config--nudge');
        this.outOfStockButton = this.el.querySelector('.summary-out-of-stock')

        this.bind();
    }

    async update() {
        this.showLoader();

        await this.pricing.waitForMTOCEPricing();
        if(!this.pricing.hasPricing()) { return; }

        await this.finance.waitForFinance();

        this.render();
        Tooltip.init();
        Tooltip.init('.discount-tooltip', this.promotionsHelper.tooltipOptions);

        this.linkParams.update();
        this.checkoutSession.update();
        this.setConfiguratorLink();
        this.hideLoader();
        this.bindUpdate();
        this.parent.leadTime.update();
        this.parent.carOptions.updateDataAttributes();
        if(this.waitForFirstLoad !== true) {
            this.loaded(true);
        }
    }

    bind() {
        this.el
            .querySelector('.order-button')
            ?.addEventListener('click', (e) => {
                e.preventDefault();
                this.analyticsPush(e.currentTarget);
            });
    }

    setConfiguratorLink() {
        const link = window.location.href;
        sessionStorage.setItem('configurator-link', link);
    }

    bindUpdate() {
        this.el.querySelector('.terms-link')?.addEventListener('click', (e) => {
            e.preventDefault();
            this.navigation.scrollToSection('#terms');
        });

        [...this.el.querySelectorAll('.payment-options-link')].forEach((goToLink) => {
            goToLink.addEventListener('click', (e) => {
                e.preventDefault();
                this.navigation.scrollToSection('#configurator--finance-calculator');
            });
        })

        const scrollToLink = [...this.el.querySelectorAll('.scroll-link')];
        scrollToLink.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        });
        
        const accordionHeaders = [...this.el.querySelectorAll('.accordion-header')];
        accordionHeaders.forEach((header) => {
            header.addEventListener('click', (e) => {
                const parentItem = e.target.closest('.summary-accordion');
                parentItem.classList.toggle('active');
            });
        });
    }

    render() {
        this.content.innerHTML = this.template({
            pricingSource: this.pricingSource,
            pricing: this.pricing,
            finance: this.finance,
            financeSummary: this.finance.result,
            partEx: this.partEx,
            promotions: this.promotionsHelper.getCarPromotions(),
            formatPercent: (val) => this.percentFormatter(val),
            formatAPR: (val) => this.aprFormatter(val),
            escapeHTML,
        });

        const hasPricing = !isNaN(this.pricing.getCarTotalPrice());
        const isCashOrFinanceSuccess = this.finance.type === 'cash' || !!this.finance.result;
        const isStockEnabled = this.stockChecker.enabled;
        const inStock = isStockEnabled && this.stockChecker.isCarInStock(this.car);

        if (hasPricing && isCashOrFinanceSuccess && (!isStockEnabled || inStock)) {
            this.orderButtons.classList.remove('hide');
            this.saveConfigButton.classList.remove('hide');
            this.outOfStockButton?.classList.add('hide');
        } else {
            this.orderButtons.classList.add('hide');
            this.saveConfigButton.classList.add('hide');
            if(isStockEnabled && !inStock){
                this.outOfStockButton?.classList.remove('hide');
            }
        }
    }

    showLoader() {
        this.loader.classList.remove('hide');
    }

    hideLoader() {
        this.loader.classList.add('hide');
    }

    analyticsPush(el) {
        const documentCountryCode = document
            .querySelector('html')
            .getAttribute('country');
        const model = this.data?.model?.modelBodyCode;
        const totalPrice = this.pricing?.getCarTotalPrice();
        const mtoce = this.car?.mtoce();
        const selectedGrade = this.car?.grade;
        const selectedColour = this.car?.colour;

        AnalyticsHelper.push(el);
        AnalyticsHelper.push({ ecommerce: null }); // Clear the previous ecommerce object.
        AnalyticsHelper.push({
            event: 'begin_checkout',
            actionType: 'ecommerce - begin checkout',
            businessUnit: 'cars',
            moduleName: 'ecommerce',
            clickText: 'Continue your order online',
            clickType: 'internal',
            destinationURL: el.href,
            modelSelected: model,
            inPageLocation: '',
            countryCode: documentCountryCode,
            ecommerce: {
                currency: window.HONDA?.currency?.ISO,
                value: totalPrice,
                items: [
                    {
                        item_id: mtoce,
                        item_name: model,
                        discount: 0,
                        index: 0,
                        item_brand: 'HONDA',
                        gradeName: selectedGrade,
                        colourName: selectedColour,
                        dealerName: '',
                        price: totalPrice,
                        quantity: 1,
                    },
                ],
            },
        });
    }
}
